/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import Space from 'material/space/space';
import {  } from '@insticator/insticator-ui/dist/material';
// styles
import injectSheet from 'react-jss'
import styles from './trendingnow_styles'
import ArticleCard from 'material/articlecard/articleccard';

/* ========== ~~~~~~~~~~ PRODUCT MANAGER: PAGE SETUP : PREVIEW ~~~~~~~~~~ ========== */
const TrendingNow = injectSheet(styles)((props) => {

  const { } = props
  return (
    <div className={`trendingnow ${props.classes.trendingnow}`}>
      <Space direction={'column'}>
        <Space direction={'column'} gap={4}>
          <h5>Trending Now</h5>
          <hr />
        </Space>
        <ArticleCard direction={'horizontal'} />
        <Space>
          <ArticleCard />
          <ArticleCard />
          <ArticleCard />
        </Space>
      </Space>
    </div>
   
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default TrendingNow;
